import $ from "jquery";

export class FooterMenuModule {

    constructor() {
        $('.footer-nav .menu-item-has-children').on('click', (e) => { this.handleClick(e) });
    }

    handleClick(e) {
        if (e.target.tagName.toLowerCase() == 'li') {
            $(e.target).toggleClass('active');
        }
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/FooterMenuModule.js